import React from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import Crud from "../Crud";

/**
 * TABLE FREEPLAYOFFICEOPTIONS
 */
function OddsDefault(props) {
  let IdProfile = props.Profile.IdProfile;

  return (
    <div className="flex flex-col gap-4 h-max">
      <Crud
        title="Odds Default"
        getUrl={() => `/Profile/OddsDefault_GetList?idProfile=${IdProfile}`}
        getProcess={(data) =>
          data.map((item) => {
            const idProfileVal = item.idProfile ?? item.IdProfile;
            const idSportVal = item.idSport ?? item.IdSport;
            const oddsVal = item.odds ?? item.Odds;
            return {
              idComposed: `${idProfileVal}-${idSportVal}`,
              idProfile: idProfileVal,
              idSport: idSportVal,
              odds: oddsVal,
            };
          })
        }
        // UPDATE
        updateUrl={({ userId }, row) =>
          `/Profile/OddsDefault_Update?idProfile=${row.idProfile}&idSport=${row.idSport}&Odds=${row.odds}&idUser=${userId}`
        }
      // DELETE
      // deleteUrl={() => "/Profile/OddsDefault_Delete"}
      // deleteParams={({ userId }, _, { idProfile, idSport }) => ({
      //   IdProfile: idProfile,
      //   IdSport: idSport,
      //   IdUser: Number(userId),
      // })}
      >
        <TableHeaderColumn
          visible="none"
          hiddenOnInsert
          autoValue={true}
          hidden
          isKey
          dataField="idComposed"
        >
          IdComposed
        </TableHeaderColumn>
        <TableHeaderColumn
          visible="none"
          hiddenOnInsert
          autoValue={true}
          hidden
          dataField="idProfile"
        >
          IdProfile
        </TableHeaderColumn>
        <TableHeaderColumn dataField="idSport">Sport</TableHeaderColumn>
        <TableHeaderColumn dataField="odds">Odds</TableHeaderColumn>
      </Crud>
    </div>
  );
}

export default OddsDefault;
